import { render } from "./TarievenView.vue?vue&type=template&id=37a5fbf7&scoped=true"
import script from "./TarievenView.vue?vue&type=script&lang=js"
export * from "./TarievenView.vue?vue&type=script&lang=js"

import "./TarievenView.vue?vue&type=style&index=0&id=37a5fbf7&scoped=true&lang=scss"

import exportComponent from "E:\\Old Files\\Projecten Web\\Q-Mobile\\frame\\q-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a5fbf7"]])

export default __exports__